
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 21 21","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 10.5c0 5.253-4.247 9.5-9.5 9.5A9.492 9.492 0 011 10.5C1 5.247 5.247 1 10.5 1S20 5.247 20 10.5z","stroke":"currentColor","stroke-width":"1.5","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M7.61 14.2L5.38 6.96h1.35l1.06 3.52c.193.64.377 1.277.55 1.91h.02c.12-.44.31-1.08.57-1.92l1.09-3.51h.93l1.09 3.52c.24.767.43 1.403.57 1.91h.02c.22-.793.403-1.433.55-1.92l1.06-3.51h1.29l-2.24 7.24h-1.35l-.96-3.1c-.24-.787-.413-1.367-.52-1.74h-.02c-.147.507-.317 1.08-.51 1.72l-.97 3.12H7.61z","fill":"currentColor"}})])
          )
        }
      }
    